import { TypedDocumentNode } from '@apollo/client'
import { useMutation } from '@apollo/client/react'
import { AdminCreateTranslationContentMutationDocument } from '@docpace/admin-graphql/dist/urql.types'
import { AdminCreateTranslationContentMutationResultFragment, AdminCreateTranslationContentMutationParams } from '@docpace/admin-graphql'

const typedAdminCreateTranslationContentMutationDocument = AdminCreateTranslationContentMutationDocument as TypedDocumentNode<AdminCreateTranslationContentMutationResultFragment, Partial<AdminCreateTranslationContentMutationParams>>

export function useAdminCreateTranslationContentMutation(opts?: useMutation.Options<AdminCreateTranslationContentMutationResultFragment, Partial<AdminCreateTranslationContentMutationParams>>){
    return useMutation(typedAdminCreateTranslationContentMutationDocument, opts)
}
